import React, { Component } from "react";   

class Loader extends Component { 
  render() { 
    return ( 
      <>  
        <div className="d-flex pb-5  pt-5 justify-content-center"> 
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div> 
        </>  
    );
  }
}
export default Loader;